import { render, staticRenderFns } from "./ClientCommentsPopup.vue?vue&type=template&id=1015d304"
import script from "./ClientCommentsPopup.vue?vue&type=script&lang=js"
export * from "./ClientCommentsPopup.vue?vue&type=script&lang=js"
import style0 from "./ClientCommentsPopup.vue?vue&type=style&index=0&id=1015d304&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports